import { router } from '%app/js/common/services/router';
import isNonEmptyString from './isNonEmptyString';

const EVENT_DETAIL_ROUTE = 'evp_ticket_frontend.single_event.event_info';

export default function buildEventDetailHref(slug) {
    if (!isNonEmptyString(slug)) {
        return undefined;
    }
    return router.generatePath(EVENT_DETAIL_ROUTE, { slug });
}
